module.exports = __webpack_public_path__ + "static/media/tz.ad560bfd.svg";